import { render, staticRenderFns } from "./AppAddresses.vue?vue&type=template&id=667565bc&scoped=true&"
import script from "./AppAddresses.vue?vue&type=script&lang=js&"
export * from "./AppAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667565bc",
  null
  
)

export default component.exports